import * as Sentry from '@sentry/browser';

export const reportError = (action, err) => Sentry.captureException(err, {
  tags: { module: 'MassTextOutreach', action },
});
